export const psychologyConst = {
  path: "/single-programs/psychology",
  title: "ФАКУЛЬТЕТ СОЦИАЛЬНЫХ НАУК – ПСИХОЛОГИЯ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом: </strong>бакалавра / магистра
      </p>
      <p>
        <strong>Формы обучения: </strong>очно или дистанционно
      </p>
      <p>
        <strong>Форма связи: </strong>Получить консультацию приемной комиссии
      </p>
      <h2>Психология — понимание человека начинается здесь</h2>
      <p>
        Психология — это ключ к пониманию мышления, эмоций и поведения. Программа охватывает все основные направления: от общей и
        когнитивной психологии до клинической практики и психотерапии. Студенты осваивают методы диагностики, консультирования и работы с
        различными категориями клиентов.
      </p>
      <p>Обучение построено на научной базе, практических кейсах и этических стандартах профессии.</p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Общая и когнитивная психология</li>
        <li>Психология личности и развития</li>
        <li>Психодиагностика и методы исследования</li>
        <li>Основы психотерапии и консультирования</li>
        <li>Клиническая психология и нейропсихология</li>
        <li>Психология стресса и кризисных состояний</li>
        <li>Психология общения и конфликтов</li>
        <li>Этические и правовые аспекты психологической практики</li>
      </ul>
      <p>В программу входят практические занятия, супервизии, работа с клиентами и стажировки в клиниках, центрах и HR-отделах компаний.</p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Психолог-консультант</li>
        <li>Клинический психолог (при наличии лицензии в стране проживания)</li>
        <li>HR-специалист или карьерный коуч</li>
        <li>Специалист по психодиагностике и тестированию</li>
        <li>Психолог в образовательных учреждениях</li>
        <li>Исследователь в области психологии и нейронаук</li>
      </ul>
      <h2>Зарплата в Европе:</h2>
      <p>
        от <strong>€45,000 до €85,000 в год</strong>
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом с возможностью продолжения обучения в магистратуре и аспирантуре</li>
        <li>Гибкие формы обучения: очно или дистанционно</li>
        <li>Преподаватели — практикующие психологи и учёные</li>
        <li>Обучение на русском или английском языке</li>
        <li>Практика и супервизия в профессиональной среде</li>
        <li>Поддержка при поступлении и карьерном росте от приёмной комиссии</li>
      </ul>
      <p>Психология — это профессия, в центре которой человек</p>
      <p>
        Наши выпускники помогают людям справляться с трудностями, развиваться и восстанавливать внутреннее равновесие. Они работают в
        клиниках, компаниях, школах и частной практике по всей Европе.
      </p>
      <p>«Понимание — первый шаг к изменениям. Мы учим делать этот шаг профессионально.»</p>
      <h2>Как поступить?</h2>
      <p>Приёмная комиссия поможет вам подобрать программу, собрать документы и пройти весь путь поступления.</p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра / магистра
    Формы обучения: очно или дистанционно
    Форма связи: Получить консультацию приемной комиссии
    Психология — понимание человека начинается здесь
    Психология — это ключ к пониманию мышления, эмоций и поведения. Программа охватывает все основные направления: от общей и когнитивной психологии до клинической практики и психотерапии. Студенты осваивают методы диагностики, консультирования и работы с различными категориями клиентов.
    Обучение построено на научной базе, практических кейсах и этических стандартах профессии.
    Что вы будете изучать?
    • Общая и когнитивная психология
    • Психология личности и развития
    • Психодиагностика и методы исследования
    • Основы психотерапии и консультирования
    • Клиническая психология и нейропсихология
    • Психология стресса и кризисных состояний
    • Психология общения и конфликтов
    • Этические и правовые аспекты психологической практики
    В программу входят практические занятия, супервизии, работа с клиентами и стажировки в клиниках, центрах и HR-отделах компаний.
    Кем можно работать после окончания?
    • Психолог-консультант
    • Клинический психолог (при наличии лицензии в стране проживания)
    • HR-специалист или карьерный коуч
    • Специалист по психодиагностике и тестированию
    • Психолог в образовательных учреждениях
    • Исследователь в области психологии и нейронаук
    Зарплата в Европе: от €45,000 до €85,000 в год
    Почему выбирают нас?
    • Европейский диплом с возможностью продолжения обучения в магистратуре и аспирантуре
    • Гибкие формы обучения: очно или дистанционно
    • Преподаватели — практикующие психологи и учёные
    • Обучение на русском или английском языке
    • Практика и супервизия в профессиональной среде
    • Поддержка при поступлении и карьерном росте от приёмной комиссии
    Психология — это профессия, в центре которой человек
    Наши выпускники помогают людям справляться с трудностями, развиваться и восстанавливать внутреннее равновесие. Они работают в клиниках, компаниях, школах и частной практике по всей Европе.
    «Понимание — первый шаг к изменениям. Мы учим делать этот шаг профессионально.»

    Как поступить?
    Приёмная комиссия поможет вам подобрать программу, собрать документы и пройти весь путь поступления.
  `,
};
